export enum LocalizationId {
    LogoutMenuItem = "nav-menu.logout_menu_item",
    ProfileMenuItem = "nav-menu.profile_menu_item",
}
